import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { ThemePalette } from "@angular/material/core";
import { MatTableDataSource } from "@angular/material/table";
import { ServidorRecad } from 'app/model/servidorRecad';
import { ToastrService } from "ngx-toastr";
import { DocumentosPosRecadDto } from "./documentosPosRecad.dto";
import { PosCampanhaServiceAba4 } from "app/service/posCampanhaAba4/pos-campanha-aba4.service";
import { Observable } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { ModalComponent } from "app/components/modal/modal.component";

type DadosTabela = {
  descricao: string;
  informacaoSrh: string;
  informacaoRecad: string;
  anexo: string;
  check: boolean;

}

@Component({
  selector: 'app-aba4-posrecad',
  templateUrl: './aba4-posrecad.component.html',
  styleUrls: ['./aba4-posrecad.component.sass']
})
export class Aba4PosrecadComponent implements OnInit {
  @Input() servidor: ServidorRecad;
  @Output() flExibirTab: EventEmitter<any> = new EventEmitter<any>();
  @Output() salvoOutput: EventEmitter<any> = new EventEmitter<any>();
  @Output() botoesDesabilitadosDocumentos: EventEmitter<any> = new EventEmitter<any>();
  @Input() btnDesativadoDocumentos: boolean;

  displayedColumns: string[] = ['descricao', 'informacaoSrh', 'informacaoRecad'];
  displayedColumnsCNH: string[] = ['descricao', 'informacaoSrh', 'informacaoRecad'];

  dataSource: MatTableDataSource<DadosTabela> = new MatTableDataSource<DadosTabela>([]);
  dataSource1: MatTableDataSource<DadosTabela> = new MatTableDataSource<DadosTabela>([]);
  dataSource2: MatTableDataSource<DadosTabela> = new MatTableDataSource<DadosTabela>([]);
  color: ThemePalette = 'primary';
  list: DadosTabela[] = [];
  list1: DadosTabela[] = [];
  list2: DadosTabela[] = [];
  documentos: DocumentosPosRecadDto = new DocumentosPosRecadDto();
  salvo: boolean = false;
  justificativa: string = '';

  panelOpenState = false;
  isDisabledJustificativa: boolean = true
  possuiAlteracaoRg: boolean;
  possuiAlteracaoCnh: boolean;
  possuiAlteracaoTituloEleitor: boolean;


  constructor(private PosCampanhaServiceAba4: PosCampanhaServiceAba4, private toasterService: ToastrService, public dialog: MatDialog,
    ) { }

  ngOnInit(): void {
    this.processarDocsPessoais(this.servidor.id);
  }

  ngOnDestroy() {

  }

  ngOnChanges(changes: SimpleChanges) {
    this.dataSource.data = [];
    this.dataSource1.data = [];
    this.dataSource2.data = [];
    this.list = [];
    this.list1 = [];
    this.list2 = [];
    // this.justificativa = "";
    this.salvo = false;
    // this.findLotacao(this.servidor.id)
  }


  private montarDadosTabela(resp: DocumentosPosRecadDto): DadosTabela[] {
    this.list.push(
      //UfEmissao não tem no json

      { descricao: "Carteira de Identidade", informacaoSrh: resp.numeCartIdentSrh, anexo: "anexo-rg", informacaoRecad: resp.numeCartIdentRecad, check: true},
      { descricao: "Sigla Órgão Emissor", informacaoSrh: resp.descOrgEmisCartIdentSrh, anexo: "anexo-emissao", informacaoRecad: resp.descOrgEmisCartIdentRecad, check: true },
      { descricao: "UF Emissão", informacaoSrh: resp.codgUfCartIdentidadeSrh, anexo: "anexo-uf-rg", informacaoRecad: resp.codgUfCartIdentidadeRecad, check: true },
      { descricao: "Data de Expedição", informacaoSrh: resp.dataEmissaoCartIdentSrh, anexo: "anexo-data-emissao", informacaoRecad: resp.dataEmissaoCartIdentRecad, check: true },

    )
    return this.list;
  }

  private montarDadosTabela1(resp: DocumentosPosRecadDto): DadosTabela[] {
    this.list1.push(
      //Data primeira habilitacao srh, data de vencimento srh e recad não tem

      { descricao: "Número de Registro CNH", informacaoSrh: resp.numeCnhSrh != null ? resp.numeCnhSrh :'', anexo: "anexo-numero-cnh", informacaoRecad: resp.numeCnhRecad, check: true },
      { descricao: "UF Emissão", informacaoSrh: resp.ufCnhSrh, anexo: "anexo-uf-emissao-cnh", informacaoRecad: resp.ufCnhRecad, check: true },
      { descricao: "Categoria CNH", informacaoSrh: resp.descCategoriaCnhSrh, anexo: "anexo-categoria-cnh", informacaoRecad: resp.descCategoriaCnhRecad, check: true },
      { descricao: "Data de Expedição", informacaoSrh: resp.dataExpedCnhSrh, anexo: "anexo-data-cnh", informacaoRecad: resp.dataExpedCnhRecad, check: true },
      { descricao: "Data de Vencimento", informacaoSrh: resp.dataVencimentoCnhSrh, anexo: "anexo-uf-emissao-cnh", informacaoRecad: resp.dataVencimentoCnhRecad, check: true },
      { descricao: "Data Primeira Habilitação", informacaoSrh: resp.dataPrimeiraCnhRecad, anexo: "anexo-categoria-cnh", informacaoRecad: resp.dataPrimeiraCnhRecad, check: true },

    )
    return this.list1;
  }

  private montarDadosTabela2(resp: DocumentosPosRecadDto): DadosTabela[] {
    this.list2.push(

      { descricao: "Número de título de Eleitor", informacaoSrh: resp.numeTituloEleitorSrh, anexo: "anexo-numero-titulo-eleitor", informacaoRecad: resp.numeTituloEleitorRecad, check: true },
      { descricao: "Zona", informacaoSrh: resp.numeZonaTitEleitorSrh, anexo: "anexo-zona", informacaoRecad: resp.numeZonaTitEleitorRecad, check: true },
      { descricao: "Seção", informacaoSrh: resp.numeSecaoTitEleitorSrh, anexo: "anexo-zona", informacaoRecad: resp.numeSecaoTitEleitorRecad, check: true },
      { descricao: "UF", informacaoSrh: resp.ufTituloEleitorSrh, anexo: "anexo-num-titulo-eleitor", informacaoRecad: resp.ufTituloEleitorRecad, check: true },

    )
    return this.list2;
  }



  private getObterDocsPessoais(validacaoRecadId: number): Observable<DocumentosPosRecadDto> {
    return this.PosCampanhaServiceAba4.getObterDocsPessoais(validacaoRecadId);
  }

  processarDocsPessoais(validacaoRecadId: number) {
    this.getObterDocsPessoais(validacaoRecadId).subscribe(
      response => {
        if(response){
          this.documentos = response;
          this.dataSource.data = this.montarDadosTabela(response);
          this.dataSource1.data = this.montarDadosTabela1(response);
          this.dataSource2.data = this.montarDadosTabela2(response);
        } else {
          this.flExibirTab.emit(false);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }


  visualizarComprovante(comprovante: string) {
    this.getVisualizarComprovante(comprovante).subscribe(
      response => {
        const blobUrl = URL.createObjectURL(response);

        // Especifica as dimensões da nova janela (largura x altura)
        const newWindow = window.open(blobUrl, '_blank', 'width=800,height=800');

        // Verifica se a janela foi aberta com sucesso
        if (newWindow) {
          newWindow.focus();
        } else {
          this.toasterService.warning('Erro ao abrir a nova janela.', '', {
            timeOut: 1500
          });
        }
      },
      error => {
        this.toasterService.warning('Erro ao visualizar a imagem', '', {
          timeOut: 1500
        });

      }
    );
  }
  getVisualizarComprovante(comprovante): Observable<any> {
    return this.PosCampanhaServiceAba4.getObterArquivos(comprovante, this.documentos.recadValidacaoDocPessoaisId);
  }
  openDialog(): void {
    this.dialog.open(ModalComponent, {
      width: '450px',
      data: {
        header: 'Justificativa',
        descricao: 'Justifique o motivo de recusa:',
        labelOne: 'Cancelar',
        labelTwo: 'Salvar',
        flTextArea: true,
        action: (justificativa: string) => {
          this.justificativa = justificativa;
          this.aprovar(3)
          this.botoesDesabilitadosDocumentos.emit(true);

        }
      }
    });
  }
  rejeitar(){
    this.isDisabledJustificativa = false
    this.openDialog();
  }

  aprovar(status){
    /*
    status
    1- aceito
    2-pendente
    3- recusado
    * */
    this.botoesDesabilitadosDocumentos.emit(true);
    if(status == 1){
      this.justificativa = ''
    }
    let body = {
      status: status,
      justificativa: this.justificativa,
    }
    this.PosCampanhaServiceAba4.salvarDocumentos(this.servidor.id, body).subscribe( resp => {
      this.toasterService.success("Dados salvos com sucesso");
      this.salvo = true;
      this.salvoOutput.emit(true);
    }, error => {
      this.salvo= false
      this.toasterService.error('Erro ao salvar os dados.', '', {
        timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
      console.error(error)

    });
  }
}
